import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
// @ts-check
import { SyncWalker } from './sync.js';
import { AsyncWalker } from './async.js';
/** @typedef { import('estree').BaseNode} BaseNode */

/** @typedef { import('./sync.js').SyncHandler} SyncHandler */

/** @typedef { import('./async.js').AsyncHandler} AsyncHandler */

/**
 *
 * @param {BaseNode} ast
 * @param {{
 *   enter?: SyncHandler
 *   leave?: SyncHandler
 * }} walker
 * @returns {BaseNode}
 */

export function walk(ast, _ref) {
  var enter = _ref.enter,
      leave = _ref.leave;
  var instance = new SyncWalker(enter, leave);
  return instance.visit(ast, null);
}
/**
 *
 * @param {BaseNode} ast
 * @param {{
 *   enter?: AsyncHandler
 *   leave?: AsyncHandler
 * }} walker
 * @returns {Promise<BaseNode>}
 */

export function asyncWalk(_x, _x2) {
  return _asyncWalk.apply(this, arguments);
}

function _asyncWalk() {
  _asyncWalk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ast, _ref2) {
    var enter, leave, instance;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enter = _ref2.enter, leave = _ref2.leave;
            instance = new AsyncWalker(enter, leave);
            _context.next = 4;
            return instance.visit(ast, null);

          case 4:
            return _context.abrupt("return", _context.sent);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _asyncWalk.apply(this, arguments);
}